import { useAppAccessToken } from '@/src/context/app-access-token/app-access-token-context'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import { useMessage } from '@/src/context/message/message-context'
import { useShoppingCart } from '@/src/context/shopping-cart/shopping-cart-context'
import { CouponService } from '@/src/services/benefits/coupon-service'
import { useSearchParams, usePathname, useRouter } from 'next/navigation'
import React, { useEffect, useRef, useState } from 'react'

export default function CheckCoupon() {
    const searchParams = useSearchParams()
    const router = useRouter()
    const { shoppingCart, addCoupon } = useShoppingCart()
    const { showMessage } = useMessage()
    const { merchantSummary } = useMerchant()
    const { appAccessToken } = useAppAccessToken()
    const hasFetched = useRef(false)
    const pathname = usePathname()

    const [isMounted, setIsMounted] = useState(false)

    useEffect(() => {
        const couponName = searchParams.get('coupon')

        const applyCoupon = async () => {
            try {
                if (!merchantSummary || !shoppingCart || !appAccessToken || hasFetched.current || !isMounted)
                    return

                if (shoppingCart.coupon?.name === couponName)
                    return showMessage(`Cupom ${couponName} já aplicado.`)

                const response = await CouponService.getByName(
                    encodeURIComponent(couponName!),
                    merchantSummary.id!,
                    appAccessToken
                )

                if (response.status === 404)
                    return showMessage(`Cupom ${couponName} inválido.`)

                if (!response.success || !response.model)
                    throw new Error(response.errorMessage)

                addCoupon(response.model)

                showMessage(`Cupom ${response.model.name} aplicado com sucesso!`, {
                    type: 'success',
                    emptyMessagesOnRouteChange: false
                })

                hasFetched.current = true
            }
            catch (error) {
                showMessage((error as Error).message)
            }
            finally {
                if (pathname.startsWith('/app/coupon')) {
                    router.replace('/')
                }
                else {
                    const params = new URLSearchParams(searchParams.toString())
                    const couponParam = params.get('coupon')

                    if (couponParam) {
                        params.delete('coupon')
                        const newQuery = params.toString()
                        const newUrl = newQuery ? `?${newQuery}` : window.location.pathname
                        router.replace(newUrl)
                    }
                }
            }
        }

        if (couponName && !hasFetched.current)
            applyCoupon()

        if (!couponName && pathname.startsWith('/app/coupon'))
            router.replace('/')
    }, [merchantSummary, appAccessToken, isMounted])

    useEffect(() => {
        setIsMounted(true)
    }, [])

    return <></>
}
